// extracted by mini-css-extract-plugin
export var compareAtPrice = "line-item-module--compareAtPrice--874a4";
export var details = "line-item-module--details--91844";
export var lineItem = "line-item-module--lineItem--159e4";
export var price = "line-item-module--price--0b146";
export var productTitle = "line-item-module--productTitle--4f9b0";
export var remove = "line-item-module--remove--fd35f";
export var thumbnail = "line-item-module--thumbnail--32d45";
export var thumbnailImage = "line-item-module--thumbnailImage--59929";
export var titleSegment = "line-item-module--titleSegment--45653";